module.exports = __webpack_public_path__ + "static/img/lcw_03.ed59a92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zh/lcw_03.jpg
// module id = pENh
// module chunks = 0